import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const communicationLogService = {
  getAllCommunicationLogs,
  resendCommunicationLog,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  if (filter?.purpose) params.purpose = filter.purpose
  if (filter?.methodId != null && filter?.methodId !== '') params.method_id = filter.methodId
  if (filter?.isUsed != null && filter?.isUsed !== '') params.is_used = filter.isUsed
  filter?.searchArray?.forEach((word, idx) => {
    if (word !== null && word !== '') params[`search_words[${idx}]`] = word
  })
  return params
}

export function getAllCommunicationLogs(filter) {
  return apiHelper(API_URL).get('/communication-logs', { params: buildParams(filter) })
}

export function resendCommunicationLog(id) {
  return apiHelper(API_URL).post(`/communication-logs/${id}/resend`)
}
